import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const DebiaResultWay = () => {
  return <CommonResult />;
};

export default DebiaResultWay;
